import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CustomerPOCArrayModel,
  CustomerPOCModel,
} from "../../models/CustomerPOCModel";

const initialState: CustomerPOCArrayModel = {
  allCustomerPOCs: [],
  bidCreationCustomerPOCs: [],
};
const CustomerPOCSlice = createSlice({
  name: "CustomerPOC",
  initialState: initialState,
  reducers: {
    setCustomerPOCs(state, action: PayloadAction<CustomerPOCModel[]>) {
      state.allCustomerPOCs = action.payload;
    },
    setBidCreationCustomerPOCs(
      state,
      action: PayloadAction<CustomerPOCModel[]>
    ) {
      state.bidCreationCustomerPOCs = action.payload;
    },
  },
});
export default CustomerPOCSlice;
